import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'

export const CustomCodeSettings = (settingsProps) => {
  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="code"
          type="code"
          label="Code"
          defaultValue={defaultProps['code']}
        />
      </ToolbarSection>
    </>
  )
}

export const CustomCodeFloatingSettings = () =>
  React.createElement(CustomCodeSettings, { floating: true })
